<template>
    <div class="question">
        <h2>Wat voor type aansluiting heb je?</h2>
        <span class="description">Dit vind je terug op de energierekening.</span>
        <radio-select images="https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/small.svg,https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/large.svg" values="small,large" name="connectionType" labels="Minder of gelijk aan 3 x 80 ampère,Meer dan 3 x 80 ampère" setter="setConnectionType"></radio-select>
        <p
          class="notice"
          v-if="this.$store.state.variables.connectionType === 'small'"
        >
          Ons zusterbedrijf ELIX is gespecialiseerd in installaties met een aansluitwaarde onder de 3x 80 ampere. Zij zullen daarom contact met u opnemen.
        </p>
    </div>
</template>

<script>
import RadioSelect from './helpers/radio-select'

export default {
  name: 'Q3',
  components: {
    'radio-select': RadioSelect
  }
}
</script>

<style scoped>
  .notice {
    padding: 10px;
    border-radius: 4px;
    background: rgba(16, 91, 195, 0.1);
    margin-top: 10px;
    border: 2px solid #105bc3;
    color: #105bc3;
    line-height: 1.8;
  }
</style>



// WEBPACK FOOTER //
// src/components/Q3.vue